import React from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";
import InactivityWrapper from "./components/InactivityWrapper";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { SettingsProvider, SettingsConsumer } from "./contexts/settings-context";
import { createTheme } from "./theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <SettingsProvider>
          <SettingsConsumer>
            {({ settings }) => {
              const theme = createTheme({
                direction: settings.direction,
                responsiveFontSizes: settings.responsiveFontSizes,
                mode: settings.theme,
              });
              
              return (
                <ThemeProvider theme={theme}>
                   <CssBaseline />
                   <HelmetProvider>
                     <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                       <InactivityWrapper />
                       <Toaster />
                     </Router>
                   </HelmetProvider>
                 </ThemeProvider>
              );
            }}
          </SettingsConsumer>
        </SettingsProvider>
        {process.env.REACT_APP_SHOW_DEVTOOLS === 'true' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </Provider>
  );
}

export default App;